<style lang="scss" scoped>
.associated-product-wrapper {
    min-height: 60.5px;
    display: flex;

    @media screen and (min-width: 768px) {
        min-height: 120.5px;
    }
}

.associated-product {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: column;

    @media screen and (min-width: 768px) {
        flex-direction: row;
        flex-wrap: nowrap;
    }

    .thumbnail {
        width: 60.5px;
        height: 60.5px;
        position: relative;
        border: 0.5px solid #979797;
        border-radius: 4px;
        overflow: hidden;
        margin-right: 8px;
        flex-shrink: 0;
        flex-grow: 0;

        @media screen and (min-width: 768px) {
            width: 120.5px;
            height: 120.5px;
            margin-right: 16px;
        }

        img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            object-fit: fill;
            object-position: center;
        }
    }

    .left-wrapper {
        display: flex;

        a {
            color: #7f7f7f;
            font-size: 0.875rem;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 1.375rem;
            border-bottom: 1px solid #7f7f7f;
            transition: border-color 0.2s;

            &:hover {
                border-color: transparent;
            }
        }

        .copy {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;

            @media screen and (min-width: 768px) {
                flex-direction: column;
            }

            .name-link {
                h3 {
                    font-size: 1.125rem;
                    line-height: 1.4375rem;
                    font-weight: 700;
                    margin-bottom: 8px;
                    margin-right: 16px;
                }
            }
            .pricing {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                text-align: right;
                flex-shrink: 0;

                @media screen and (min-width: 768px) {
                    flex-direction: row;
                    text-align: left;
                }

                .price {
                    font-size: 1.125rem;
                    font-weight: 700;
                    letter-spacing: 0;
                    line-height: 1.4375rem;
                    margin-bottom: 8px;

                    @media screen and (min-width: 768px) {
                        padding-right: 8px;
                        margin-bottom: 0;
                    }
                }

                .text {
                    color: #7f7f7f;
                    font-size: 0.875rem;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 1;
                    padding-bottom: 0.1875rem;
                }
            }
        }
    }

    .right-wrapper {
        padding-top: 8px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;

        button {
            width: 52px;
            height: 52px;
            position: relative;

            ::v-deep svg {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translateX(-50%) translateY(-50%);
            }
        }

        input {
            width: 80px;
            height: 52px;
            text-align: center;
        }
    }

    .component-fade-enter-active,
    .component-fade-leave-active {
        transition: opacity 0.3s ease;
    }
    .component-fade-enter,
    .component-fade-leave-to {
        opacity: 0;
    }
}
</style>

<template>
    <div class="associated-product-wrapper">
        <transition name="component-fade" mode="out-in">
            <div v-if="ready && product != null" key="ready" class="associated-product">
                <div class="left-wrapper">
                    <div class="thumbnail">
                        <img :data-src="firstImage" class="lazyload" :alt="product.name">
                    </div>
                    <div class="copy">
                        <div class="name-link">
                            <h3 v-html="product.name"></h3>
                            <a :href="`/product/${product.slug}`" v-if="product.variants.length > 1">Bekijk product</a>
                        </div>
                        <div class="pricing" v-if="product.variants.length === 1">
                            <span class="price">&euro; {{ $store.getters['pricesIncludingVat'] ? product.variants[0].price_vat_incl : product.variants[0].price }}</span>
                            <span class="text" v-if="$store.getters['pricesIncludingVat']">Inclusief BTW</span>
                            <span class="text" v-else>Exclusief BTW</span>
                        </div>
                    </div>
                </div>
                <div class="right-wrapper" v-if="product.variants.length === 1">
                    <input type="number" class="last:mr-0 mr-8" v-model="amount">
                    <button class="btn btn-green btn-sm btn-rounded last:mr-0 mr-8" @click="addToCart" v-html="svg('plus')"></button>
                </div>
            </div>
            <div key="loading" v-else class="flex items-center justify-center flex-1">
                <spinner></spinner>
            </div>
        </transition>
    </div>
</template>

<script>
import { bus } from '@/app';
import lazyProduct from '@mixins/components/lazy-product';

export default {
    name: "Ui.AssociatedProduct",

    mixins: [lazyProduct],

    data() {
        return {
            amount: 1,
        }
    },

    methods: {
        addToCart() {
            this.$store.dispatch('addProduct', {
                productData: this.product,
                variant: this.product.variants[0],
                amount: this.amount
            })

            bus.$emit('slideout', 'shopping-basket');
            bus.$emit('shopping-basket-message', 'Je product is toegevoegd');
        }
    },
}
</script>